export default "__VITE_ASSET__YIJDMeQ9__"